import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, ShieldCheck } from 'lucide-react';
import { Container } from './ui/Container';
import { Button } from './ui/Button';
export function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();
  const navigation = [{
    name: 'Home',
    href: '/'
  }, {
    name: 'Services',
    href: '/services'
  }, {
    name: 'Pricing',
    href: '/pricing'
  }, {
    name: 'About',
    href: '/about'
  }];
  const isActive = (path: string) => location.pathname === path;
  return <header className="sticky top-0 z-50 w-full border-b border-slate-200 bg-white/80 backdrop-blur-md" data-id="element-114">
      <Container data-id="element-115">
        <div className="flex h-16 items-center justify-between" data-id="element-116">
          <Link to="/" className="flex items-center space-x-2" data-id="element-117">
            <ShieldCheck className="h-8 w-8 text-blue-600" data-id="element-118" />
            <span className="text-xl font-bold text-slate-900" data-id="element-119">DanyCredit</span>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-8" data-id="element-120">
            {navigation.map(item => <Link key={item.name} to={item.href} className={`text-sm font-medium transition-colors hover:text-blue-600 ${isActive(item.href) ? 'text-blue-600' : 'text-slate-600'}`} data-id="element-121">
                {item.name}
              </Link>)}
            <Link to="/contact" data-id="element-122">
              <Button size="sm" data-id="element-123">Request Consultation</Button>
            </Link>
          </nav>

          {/* Mobile Menu Button */}
          <button className="md:hidden p-2 text-slate-600" onClick={() => setIsMenuOpen(!isMenuOpen)} aria-label="Toggle menu" data-id="element-124">
            {isMenuOpen ? <X className="h-6 w-6" data-id="element-125" /> : <Menu className="h-6 w-6" data-id="element-126" />}
          </button>
        </div>
      </Container>

      {/* Mobile Navigation */}
      {isMenuOpen && <div className="md:hidden border-t border-slate-200 bg-white" data-id="element-127">
          <Container className="py-4 space-y-4" data-id="element-128">
            {navigation.map(item => <Link key={item.name} to={item.href} className={`block text-base font-medium ${isActive(item.href) ? 'text-blue-600' : 'text-slate-600'}`} onClick={() => setIsMenuOpen(false)} data-id="element-129">
                {item.name}
              </Link>)}
            <Link to="/contact" onClick={() => setIsMenuOpen(false)} className="block pt-2" data-id="element-130">
              <Button className="w-full" data-id="element-131">Request Consultation</Button>
            </Link>
          </Container>
        </div>}
    </header>;
}